import { createContext, useContext } from "react";

export type CurrentTaskContextValue = {
    inputCount: number;
};
export const currentTaskContext = createContext<CurrentTaskContextValue>(null);

export function useCurrentTask({ignoreError = false}) {
    const ctx = useContext(currentTaskContext);
    if (ctx == null && !ignoreError) throw new Error("useCurrentTask must be used within a CurrentTaskProvider");
    return ctx;
}